import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, FormGroup, FormControl, Button } from "react-bootstrap";
import { becomePartnerAction } from "../../../../redux/Auth/AuthSlice";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { useTranslation } from "react-i18next";
import { IconButton, Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../../Asset/scss/takemyyacht.scss";

function BecomePartner() {
  const { t } = useTranslation();
  const [showSuccess, setShowSuccess] = useState(false);
  const [fullName, setFullName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [businessType, setBusinessType] = useState("yachtOwner");
  const [tel, setTel] = useState("");
  const [message, setMessage] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const dispatch = useDispatch();

  const handleTelChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setTel(value);
  };

  const handleCheckboxChange = (e) => setIsChecked(e.target.checked);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !fullName ||
      !jobTitle ||
      !company ||
      !country ||
      !businessType ||
      !tel ||
      !email ||
      !message
    ) {
      setSnackbarMsg(t("All fields are required."));
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    const partnerData = {
      recipient: "info@takemyyacht.com",
      fullName,
      jobTitle,
      company,
      country,
      businessType,
      tel,
      email,
      message,
    };

    try {
      const result = await dispatch(becomePartnerAction(partnerData));
      if (result.status === "success") {
        setShowSuccess(true);
        setFullName("");
        setJobTitle("");
        setCompany("");
        setCountry("");
        setBusinessType("yachtOwner");
        setEmail("");
        setTel("");
        setMessage("");
        setSnackbarMsg(t("Your request has been submitted successfully."));
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };

  const handleClose = () => setShowSuccess(false);

  return (
    <>
      <div className="relative">
        <div className="mb-4 text-center">
          <img className="BoatHelm-1" draggable={false} src={BoatHelm} alt="BoatHelm" />
          <h2>{t("Become a Partner")}</h2>
        </div>

        <Form className="become-partner-form mx-auto text-start" onSubmit={handleSubmit}>
          {/* Full Name */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Full Name")} *</Form.Label>
            <FormControl
              type="text"
              placeholder={t("Full Name")}
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </FormGroup>

          {/* Job Title */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Job Title")} *</Form.Label>
            <FormControl
              type="text"
              placeholder={t("Job Title")}
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
            />
          </FormGroup>

          {/* Company */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Company")}</Form.Label>
            <FormControl
              type="text"
              placeholder={t("Company")}
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
          </FormGroup>

          {/* Country */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Country")}</Form.Label>
            <FormControl
              type="text"
              placeholder={t("Country")}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </FormGroup>

          {/* Business Email */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Business Email")} *</Form.Label>
            <FormControl
              type="email"
              placeholder={t("Email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>

          {/* Business Type */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Business Type")} *</Form.Label>
            <div className="btn-business-type">
              <Button
                type="button"
                className={businessType === "yachtOwner" ? "btn-type active" : "btn-type"}
                onClick={() => setBusinessType("yachtOwner")}
              >
                {t("Yacht Owner")}
              </Button>
              <Button
                type="button"
                className={businessType === "yachtAgent" ? "btn-type active" : "btn-type"}
                onClick={() => setBusinessType("yachtAgent")}
              >
                {t("Yacht Agent")}
              </Button>
            </div>
          </FormGroup>

          {/* Phone */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Phone")}</Form.Label>
            <FormControl
              type="tel"
              placeholder={t("Tel.")}
              value={tel}
              onChange={handleTelChange}
            />
          </FormGroup>

          {/* Message */}
          <FormGroup className="form-group">
            <Form.Label className="form-label">{t("Message")}</Form.Label>
            <FormControl
              as="textarea"
              rows={2}
              placeholder={t("Description")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormGroup>

          {/* Checkbox */}
          <FormGroup className="form-group checkbox-group pl-20">
            <input
              className="form-check-input me-2"
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              id="flexCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              {t(
                "By proceeding, you indicate you have read and agree to the Cookie Policy. And Privacy Policy"
              )}
            </label>
          </FormGroup>

          <Button className="submit-btn" type="submit" disabled={!isChecked}>
            {t("Submit")}
          </Button>
        </Form>

        {showSuccess && (
          <div className="ContainerContact" onClick={handleClose}>
            <div className="CenteredModal" onClick={(e) => e.stopPropagation()}>
              <div className="ContactHeader">
                <h2 className="TextContact">{t("Become a Partner")}</h2>
                <IconButton className="CloseButtonContact" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </div>
              <p className="TextThankContact">
                {t("We will get back to you as soon as possible.")}
              </p>
              <Button id="province-dropdown" variant="primary" onClick={handleClose}>
                {t("Done")}
              </Button>
            </div>
          </div>
        )}
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ borderRadius: 2 }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default BecomePartner;
